import React, { useEffect, useState } from "react";
import { DEFAULT_AVATAR, resolveAvatarUrl } from "./avatar";

/**
 * Shows local default immediately, then swaps to the desired src if it loads.
 * If the desired src fails, it reverts to the local default.
 */
export default function AvatarImg({
  src,                      // string | undefined (from DB)
  alt = "Avatar",
  className,
  style,
  fetchPriority = "high",   // helps mobile show it ASAP
}) {
  const [imgSrc, setImgSrc] = useState(DEFAULT_AVATAR);

  useEffect(() => {
    const target = resolveAvatarUrl(src);
    if (target === DEFAULT_AVATAR) {
      setImgSrc(DEFAULT_AVATAR);
      return;
    }
    // optimistic: keep default visible, then try loading target
    const img = new Image();
    img.onload = () => setImgSrc(target);
    img.onerror = () => setImgSrc(DEFAULT_AVATAR);
    img.src = target;
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      style={style}
      loading="eager"
      decoding="async"
      fetchpriority={fetchPriority}
      onError={() => setImgSrc(DEFAULT_AVATAR)}
    />
  );
}
